const iconButton = {
  styleOverrides: {
    root: {
      // themeDark doesn't set palette.mode: "dark", so MUI never computes
      // dark defaults for action.active. Default IconButtons therefore render
      // dark on dark surfaces (the close icon disappears against a dark
      // DialogTitle). Inherit the parent's text color so the icon matches
      // whatever surface it sits in. Explicit color="primary"/"error" props
      // still override this via the MUI color-prop styles.
      color: "inherit",
    },
    sizeSmall: {
      padding: 6,
    },
  },
};

export default iconButton;
